import { SET_APP_HOST, GET_CONFIDENTIALITY_LEVELS, GET_QUOTAS, GET_LOCATIONS, SET_NAVIGATION_KEY } from "./types";
import 'core-js/features/url-search-params';
import 'core-js/features/url';
import Api from '../services/Api'

export const setNavigation = (key) => dispatch => {
    const url = new URL(key, window.location.href);
    dispatch({
        type: SET_NAVIGATION_KEY,
        payload: key.replace(url.hash, '')
    })
}

export const setAppHost = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const hostApp = urlParams.get('hostApp');

    return {
        type: SET_APP_HOST,
        payload: hostApp,
    };
}

export const getSiteConfidentialityLevels = () => dispatch => {
    return Api.get('/ConfidentalLevel')
        .then(res => {
            dispatch({
                type: GET_CONFIDENTIALITY_LEVELS,
                payload: res.data
            });
        });
}

export const getSiteQuotas = () => dispatch => {
    return Api.get('/Quota')
        .then(res => {
            dispatch({
                type: GET_QUOTAS,
                payload: res.data
            });
        });
    }

export const getSiteLocations = () => dispatch => {
    return Api.get('/Location')
        .then(res => {
            dispatch({
                type: GET_LOCATIONS,
                payload: res.data
            });
        });
}


// WEBPACK FOOTER //
// ./src/actions/appActions.js